import { createSelector } from "@ngrx/store";
import { groupingState, State } from "./grouping.reducer";


export const selectGroupingState = (state: State) => state.grouping;

export const getGroupData = createSelector(
  selectGroupingState,
  (state: groupingState) => state.groups
)
export const getPannel = (pannelName: string) => createSelector(
  selectGroupingState,
  (state: groupingState) => state.groups.find(i => i.groupByColumnData === pannelName)
)
export const getPannelData = (pannelName: string) => createSelector(
  selectGroupingState,
  (state: groupingState) => state.groups.find(i => i.groupByColumnData === pannelName)?.pannelData
)
export const getPannelDataLength = (pannelName: string) => createSelector(
  selectGroupingState,
  (state: groupingState) => state.groups.find(i => i.groupByColumnData === pannelName)?.pannelData.length
)
export const getGroupBy = createSelector(
  selectGroupingState,
  (state: groupingState) => state.groupBy
)
export const getGroupPagination = createSelector(
  selectGroupingState,
  (state: groupingState) => state.pageIndex
)
export const getFilterType = createSelector(
  selectGroupingState,
  (state: groupingState) => state.filterType
)
export const getFilter = createSelector(
  selectGroupingState,
  (state: groupingState) => state.filter
)
export const getGroupByEnabled = createSelector(
  selectGroupingState,
  (state: groupingState) => state.groupByEnabled
)
export const getNavHeight = createSelector(
  selectGroupingState,
  (state: groupingState) => state.navHeight
)
export const getPannelOpenState = (pannelName: string) => createSelector(
  selectGroupingState,
  (state: groupingState) => state.groups.find(i => i.groupByColumnData === pannelName)?.panelOpenState
)
export const getPannelPagination = (pannelName: string) => createSelector(
  selectGroupingState,
  (state: groupingState) => {
    return {
      pageIndex: state.groups.find(i => i.groupByColumnData === pannelName)?state.groups.find(i => i.groupByColumnData === pannelName)?.pageIndex:0,
      pageSize: state.groups.find(i => i.groupByColumnData === pannelName)?state.groups.find(i => i.groupByColumnData === pannelName)?.pageSize:0
    }
  }

)
